import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { Asset } from '@schibsted-svp/svp-api-types';
import { getCategory } from 'store/categories/selectors';
import { getDynamicFields, filterDynamicFieldsForAsset } from '../helpers/DynamicForm';

export function useAssetDynamicFieldKeys(asset: Asset): (key: string) => boolean {
    const category = useSelector((state) => getCategory(state, { provider: asset.provider, id: asset.category.id }));

    return useMemo(() => {
        const dynamicFields = filterDynamicFieldsForAsset(getDynamicFields(category), asset);
        return (key: string) => dynamicFields.some((field) => field.key === key);
    }, [asset, category]);
}
